import { Switch, SwitchProps } from 'formik-mui'
import React, { useMemo } from 'react'

import { FormControlLabel } from '@mui/material'

export type SwitchFieldProps = SwitchProps & {
  label?: string
}

export function SwitchField({ className, style, label, field, ...switchProps }: SwitchFieldProps) {
  const parsedField = useMemo(() => ({ ...field, value: Boolean(field.value) }), [field])
  return (
    <FormControlLabel
      control={<Switch field={parsedField} {...switchProps} />}
      label={label}
      className={className}
      style={style}
    />
  )
}
